"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardStateless = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const Dialog_1 = require("../Dialog");
const helpers_1 = require("../helpers");
const keyCode_1 = require("../helpers/keyCode");
const TabList_1 = require("../TabList");
const PageHeader = styled_components_1.default.div `
    padding: ${helpers_1.SPACING_S} ${helpers_1.SPACING_M};
    border-bottom: ${helpers_1.BASE_BORDER_WIDTH} solid ${({ theme }) => theme.colorBorderMain};
`;
const PageTitle = styled_components_1.default.div `
    color: ${({ theme }) => theme.colorTextMain};
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    font-size: ${helpers_1.FONT_SIZE_M};
    font-weight: ${helpers_1.BASE_FONT_BOLD_WEIGHT};
    line-height: ${helpers_1.FONT_LINE_HEIGHT_M};
`;
const PageDescription = styled_components_1.default.div `
    margin: ${helpers_1.SPACING_S} 0 0 0;
`;
const TabPanelBody = styled_components_1.default.div `
    box-sizing: border-box;
    padding: ${({ hasContentPadding }) => (hasContentPadding ? `${helpers_1.SPACING_M}` : '0')};
    overflow: auto;

    width: 100%;
    height: 100%;
    overflow: auto;
`;
const TabPanel = styled_components_1.default.div `
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    overflow: hidden;
`;
const WindowBody = styled_components_1.default.div `
    background-color: #fff;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    flex: 1;
    overflow: auto;

    display: flex;
    flex-direction: row;

    position: relative;
`;
const DEFAULT_ACTIONS_TEXTS = {
    previous: 'Previous',
    next: 'Next',
    submit: 'Finish',
    cancel: 'Cancel'
};
class WizardStateless extends react_1.Component {
    constructor() {
        super(...arguments);
        this.refDialog = react_1.default.createRef();
    }
    static renderTabPanelHeader(elem) {
        return (react_1.default.createElement(PageHeader, null,
            elem.props.panelTitle && react_1.default.createElement(PageTitle, null, elem.props.panelTitle),
            elem.props.panelDescription && (react_1.default.createElement(PageDescription, null, elem.props.panelDescription))));
    }
    renderTabList(dataSelectorId) {
        const { steps, isEdit = false, activeStep, setStep } = this.props;
        return (react_1.default.createElement(TabList_1.TabList, { "data-selector-id": `${dataSelectorId}-tabs`, items: react_1.default.Children.map(steps, (elem, idx) => {
                return {
                    id: idx.toString(),
                    active: idx === activeStep,
                    completed: elem.props.completed || idx < activeStep,
                    disabled: elem.props.disabled || (!isEdit && idx > activeStep),
                    onClick: () => setStep(idx),
                    title: elem.props.title
                };
            }) }));
    }
    renderTabPanel() {
        const { onSubmit, steps, activeStep } = this.props;
        return (
        /* eslint-disable react/no-array-index-key */
        react_1.default.createElement(TabPanel, null, react_1.default.Children.map(steps, (elem, idx) => {
            const cloneElem = react_1.default.cloneElement(elem, { onSubmit });
            if (idx === activeStep) {
                return (react_1.default.createElement(react_1.default.Fragment, { key: idx },
                    (elem.props.panelTitle || elem.props.panelDescription) &&
                        WizardStateless.renderTabPanelHeader(cloneElem),
                    react_1.default.createElement(TabPanelBody, { hasContentPadding: cloneElem.props.hasContentPadding }, cloneElem)));
            }
            return null;
        }))
        /* eslint-enable */
        );
    }
    componentDidUpdate(prevProps) {
        var _a;
        if (this.props.activeStep !== prevProps.activeStep) {
            try {
                // eslint-disable-next-line react/no-find-dom-node
                (_a = (0, react_dom_1.findDOMNode)(this.refDialog.current)) === null || _a === void 0 ? void 0 : _a.focus();
            }
            catch (e) {
                // no-op
            }
        }
    }
    render() {
        const _a = this.props, { onClose, title, width = '750px', height = '450px', steps, actionsTexts: actionsTextsProp, activeStep, setStep, onSubmitClick, isLoading = false, isPending, canClose = true, prevIsDisabled = false, nextIsDisabled = false, secondaryActions, onEnterKeyDown } = _a, rest = __rest(_a, ["onClose", "title", "width", "height", "steps", "actionsTexts", "activeStep", "setStep", "onSubmitClick", "isLoading", "isPending", "canClose", "prevIsDisabled", "nextIsDisabled", "secondaryActions", "onEnterKeyDown"]);
        const actionsTexts = Object.assign(Object.assign({}, DEFAULT_ACTIONS_TEXTS), actionsTextsProp);
        const dataSelectorId = rest['data-selector-id'] || 'wizard-stateless';
        return (react_1.default.createElement(Dialog_1.Dialog, { "data-selector-id": dataSelectorId, ref: this.refDialog, onRequestClose: onClose, header: title, loading: isLoading, pending: isPending, movable: true, size: width || height
                ? { width: width || Dialog_1.DIALOG_SIZE.auto, height: height || Dialog_1.DIALOG_SIZE.auto }
                : undefined, hasSpacing: false, canClose: canClose, onKeyPress: (e) => {
                if (e.keyCode === keyCode_1.KeyCode.Enter) {
                    onEnterKeyDown === null || onEnterKeyDown === void 0 ? void 0 : onEnterKeyDown(e);
                }
            }, actions: [
                activeStep !== 0 && {
                    text: actionsTexts.previous,
                    view: Dialog_1.ACTION_VIEW.alternate,
                    disabled: isLoading || prevIsDisabled,
                    onClick: () => setStep(activeStep - 1)
                },
                {
                    text: activeStep === react_1.default.Children.count(steps) - 1
                        ? actionsTexts.submit
                        : actionsTexts.next,
                    disabled: isLoading || nextIsDisabled,
                    view: Dialog_1.ACTION_VIEW.primary,
                    onClick: () => onSubmitClick(activeStep)
                },
                {
                    text: actionsTexts.cancel,
                    disabled: isLoading,
                    view: Dialog_1.ACTION_VIEW.secondary,
                    onClick: onClose
                }
            ], secondaryActions: secondaryActions },
            react_1.default.createElement(WindowBody, null,
                this.renderTabList(dataSelectorId),
                this.renderTabPanel())));
    }
}
exports.WizardStateless = WizardStateless;
//# sourceMappingURL=WizardStateless.js.map